import { connect } from 'react-redux';
import PromotionNew from './PromotionNew';
import {PromotionCRUDActions} from '../../../actions/promotion';

// new way of actions. Has to have less memory in use;
let CRUDActions = new PromotionCRUDActions();

export default connect(
  ({promotion: {loadingItem, model}}) => ({
    title: 'Create Promotion',
    loading: loadingItem,
    model,
    initialValues: Object.assign({}, model)
  }),
  dispatch => ({
    fetch: () => dispatch(CRUDActions.createModel())
  })
)(PromotionNew)





// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionNew/index.js